import { styled } from '@mui/system';
import { Palette } from 'Palette';
import { Link } from '@mui/material';

const StyledLink = styled(Link)<{
  tone?: keyof typeof Palette;
  className?: string;
}>(({ tone = 'default', className }) => ({
  color: Palette[tone].buttonText,
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
  },
  className: `react-StyledLink ${className || ''}`.trim(),
}));

export default StyledLink;

const StyledDocumentLink = styled(Link)<{
  tone?: keyof typeof Palette;
  className?: string;
}>(({ tone = 'default', className }) => ({
  color: Palette[tone].text,
  cursor: 'pointer', // Adds a hand pointer on hover
  textDecoration: 'underline',
  className: `react-StyledDocumentLink ${className || ''}`.trim(),
}));

export { StyledDocumentLink };
